import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    required,
    SelectInput,
    ReferenceInput,
    NullableBooleanInput,
    minValue,
    SelectArrayInput,
    ReferenceArrayInput,
    AutocompleteArrayInput,
    FormDataConsumer,
    useDataProvider,
    DataProviderContext,
    NumberInput,
} from 'react-admin';

import { Ecom_Categories, Ecom_Products } from '../../custom';
import { EditToolbar } from '../../common/EditToolbar';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import { STATUSES } from '../../common/constants';
import { filterToQueryProductChildren } from './ProductCreate';
import TotalAmountInput from '../../common/inputs/TotalAmountInput';
import DiscountInput from '../../common/DiscountInput';
import FileUpload from '../../common/inputs/FileUpload';
import { createCustomGoDataProvider } from '../../services';
import { EcomProductAutoComplete } from '../../common/inputs/autoCompleteInputs/EcomProductsAutoComplete';

const ProductEdit = () => {
    let { categoryId, productTemplateId, productId } = useParams();
    if (!productTemplateId) {
        return <LoadingSection />;
    }
    const baseDataProvider = useDataProvider();
    const customDataProvider = React.useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'ecom_products', apiEndpoint: '/ecom/products' },
            ]),
        [baseDataProvider],
    );
    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <Edit
                title={<ProductTitle />}
                redirect={() => {
                    return `ecom_categories/${categoryId}/ecom_product_templates/${productTemplateId}/ecom_products`;
                }}
                id={productId}
                resource={'ecom_products'}
                mutationMode={'pessimistic'}
                transform={(data:any) => ({
                    ...data,
                    amount: Number(data.amount),
                })}

            >
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="name" fullWidth validate={[required()]} />
                    <FileUpload
                        type="VIDEO_THUMBNAIL"
                        required={true}
                        label="select images"
                        source="images"
                        accept="image/*"
                        multiple={true}
                    />
                    <FileUpload
                        type="PDF_NOTES"
                        required={true}
                        source="previewPdf"
                        label="select preview pdf"
                        accept="application/pdf"
                        multiple={false}
                    />
                    <FileUpload
                        type="PDF_NOTES"
                        required={true}
                        source="pdfUrl"
                        label="select pdf url"
                        accept="application/pdf"
                        multiple={false}
                    />
                    <SelectInput source="status" choices={STATUSES} fullWidth />
                    <NullableBooleanInput
                        source={'addressRequired'}
                        name={'Address Required'}
                        fullWidth
                    />
                    <NumberInput
                        type={'number'}
                        source="mrp"
                        prefix={'₹'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <DiscountInput />
                    <NumberInput
                        type={'number'}
                        source="gstPercentage"
                        prefix={'%'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <FormDataConsumer>
                        {({ formData, ...rest }) => {
                            return (
                                <div className="w-full">
                                    <TotalAmountInput formData={formData} source="amount" />
                                </div>
                            );
                        }}
                    </FormDataConsumer>
                    <NumberInput
                        type={'number'}
                        source="appleAmount"
                        prefix={'₹'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <NumberInput
                        type={'number'}
                        source="deliveryAmount"
                        prefix={'₹'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <NumberInput
                        type={'number'}
                        source="heightInMtr"
                        prefix={'In Meters'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <NumberInput
                        type={'number'}
                        source="widthInMtr"
                        prefix={'In Meters'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <NumberInput
                        type={'number'}
                        source="lengthInMtr"
                        prefix={'In Meters'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <NumberInput
                        type={'number'}
                        source="weightInGrams"
                        prefix={'In Grams'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <EcomProductAutoComplete label={'For Combo Products'} source={'children'} />
                    <TextInput
                        source="textDescription"
                        multiline
                        rows={4}
                        fullWidth
                        validate={[required()]}
                    />
                    <HTMLEditorInput
                        source={'htmlDescription'}
                        fullWidth
                        validate={[required(), validHtml]}
                    />
                </SimpleForm>
            </Edit>
        </DataProviderContext.Provider>
    );
};

const ProductTitle = () => {
    const record = useRecordContext<Ecom_Products>();
    const translate = useTranslate();

    console.log(record);
    return record ? (
        <span>
            {translate('resources.products.name', { smart_count: 1 })} &quot;
            {record.name}&quot;
        </span>
    ) : null;
};

export default ProductEdit;
